module.exports = __webpack_public_path__ + "img/cases-brand-hla-14.40b18832.png";